import { type IconType } from "@jsq/ds/icons";
import { PaymentMethod } from "../../../common/enums";

/**
 * Message displayed when payment instructions require manager approval before use.
 */
export const MANAGER_APPROVAL_REQUIRED_MESSAGE =
  "One or more managers must approve these payment instructions before they can be used for transactions";

/**
 * Shown when the LP session security verdict is `UNAVAILABLE` (the vendor lookup
 * failed at login). Submit is hard-blocked; this mirrors the server-side
 * `SERVICE_UNAVAILABLE` copy.
 *
 * TODO(FF-7744): final copy pending legal + design sign-off.
 */
export const SECURITY_TRIGGERS_UNAVAILABLE_MESSAGE =
  "Unable to update payment instructions. We're experiencing a temporary service issue. Please try again later.";

export const COUNTRY_MISMATCH_MESSAGE =
  "The country you selected doesn't match the country associated with the provided bank details. Please verify your country selection or check your bank information.";

export const PAYMENT_METHOD_ICON: Record<PaymentMethod, IconType> = {
  [PaymentMethod.ACH]: "university",
  [PaymentMethod.Wire]: "money-bill-transfer",
  [PaymentMethod.Check]: "money-check",
  [PaymentMethod.BACS]: "sterling-sign",
  [PaymentMethod.BECS]: "circle-dollar",
  [PaymentMethod.SEPA]: "euro-sign",
  [PaymentMethod.EFT]: "envelope-open-dollar",
  [PaymentMethod.Other]: "pen-to-square",
};
